import promiseTimeout from './promiseTimeout';

export default promiseTimeout;
